export default __webpack_public_path__ + "static/media/banner.9a71da4c.jpg";